import * as Sentry from "@sentry/vue";
import VueRouter from "vue-router";
import { ToastDanger } from "@/toast/ToastProgrammatic";
import { isSessionExpiredError } from "@/utils/AuthErrors";

export function defaultErrorHandler(error?: Error): void {
  // The HTTP interceptor is already logging the user out
  if (isSessionExpiredError(error)) {
    return;
  }

  Sentry.captureException(error);

  console.log(error);

  ToastDanger.open("An error occurred");
}

export function defaultNavigationErrorHandler(error?: Error): void {
  if (VueRouter.isNavigationFailure(error)) {
    // do nothing
    return;
  }

  defaultErrorHandler(error);
}
